import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import {
  handleGetKnowledgeBaseData,
  handlePutKnowledgeBaseData,
} from './knowledgeBase.helpers';
import {
  getKnowledgeBaseDataSuccess,
  getKnowledgeBaseDataFailure,
  putKnowledgeBaseDataSuccess,
  putKnowledgeBaseDataFailure,
} from './knowledgeBase.actions';
import { knowledgeBaseTypes } from './knowledgeBase.types';
import { handleErrors, getNotifMsg } from 'utils';
import { toast } from 'react-toastify';

const getSettings = ({ appData }) => ({
  locale: appData.locale,
});

export function* getKnowledgeBaseDataSaga({ payload }) {
  const { locale } = yield select(getSettings);
  const { channelId } = payload;
  try {
    const response = yield handleGetKnowledgeBaseData(channelId);
    yield put(getKnowledgeBaseDataSuccess(response));

    // if (response?.status === 'success') {
    //   toast.success(getNotifMsg('KNOWLEDGE_BASE_GET_DATA', locale));
    // }
  } catch (error) {
    yield put(getKnowledgeBaseDataFailure(error));
    handleErrors(error, locale);
  }
}

export function* putKnowledgeBaseDataSaga({ payload }) {
  const { locale } = yield select(getSettings);
  const { channelId, data } = payload;
  try {
    const response = yield handlePutKnowledgeBaseData(channelId, data);
    yield put(putKnowledgeBaseDataSuccess(response));
    if (response?.status === 'success') {
      toast.success(getNotifMsg('KNOWLEDGE_BASE_SEND_DATA', locale));
    }
  } catch (error) {
    yield put(putKnowledgeBaseDataFailure(error));
    handleErrors(error, locale);
  }
}

export function* onGettingKnowledgeBaseData() {
  yield takeLatest(
    knowledgeBaseTypes.GET_KNOWLEDGE_BASE_DATA,
    getKnowledgeBaseDataSaga
  );
}

export function* onPuttingKnowledgeBaseData() {
  yield takeLatest(
    knowledgeBaseTypes.PUT_KNOWLEDGE_BASE_DATA,
    putKnowledgeBaseDataSaga
  );
}

export default function* knowledgeBaseSaga() {
  yield all([
    call(onGettingKnowledgeBaseData),
    call(onPuttingKnowledgeBaseData),
  ]);
}
